"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInAppAgentMessageId = exports.createInAppAgentRunId = exports.createInAppAgentConversationId = void 0;
const cuid2_1 = require("@paralleldrive/cuid2");
// more descriptive IDs to easier debug & understand
const createInAppAgentConversationId = () => `aconv_${(0, cuid2_1.createId)()}`;
exports.createInAppAgentConversationId = createInAppAgentConversationId;
const createInAppAgentRunId = () => `arun_${(0, cuid2_1.createId)()}`;
exports.createInAppAgentRunId = createInAppAgentRunId;
const createInAppAgentMessageId = () => `amsg_${(0, cuid2_1.createId)()}`;
exports.createInAppAgentMessageId = createInAppAgentMessageId;
